import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import type { IBannerTheme } from "../StyledTrialBanner";
import { TRIAL_BANNER_HEIGHT } from "../StyledTrialBanner";

// not used right now, wanted to keep here other banner variant
const basicDiscountTheme: IBannerTheme = {
    color: colorsPalettes.carbon[0],
    background: colorsPalettes.blue[400],
    counterColor: colorsPalettes.blue[400],
};

const midnightBlueGradientDiscountTheme: IBannerTheme = {
    color: colorsPalettes.carbon[0],
    background: `linear-gradient(90deg, ${colorsPalettes.midnight[400]} 0.01%,  ${colorsPalettes.blue[400]} 141.55%)`,
    counterColor: colorsPalettes.blue[400],
};

export const discountTheme = midnightBlueGradientDiscountTheme;

export const DiscountBannerContent = styled(FlexRow)<{
    isSticky: boolean;
}>`
    position: relative;
    z-index: 1;
    align-items: center;
    justify-content: space-between;
    min-height: ${TRIAL_BANNER_HEIGHT}px;
    font-size: 1rem;
    padding: 0 24px;
    color: ${discountTheme.color};
    background: ${discountTheme.background};

    ${({ isSticky }) =>
        isSticky &&
        css`
            position: sticky;
            top: 0;
        `};

    ${SWReactIcons} {
        path {
            fill: ${discountTheme.color};
        }
    }
`;
